"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
require("swiper/swiper.scss");
require("swiper/components/navigation/navigation.scss");
require("swiper/components/scrollbar/scrollbar.scss");
require("swiper/components/pagination/pagination.min.css");
var index_1 = __importDefault(require("./sections/hero/index"));
var useCases_1 = __importDefault(require("./sections/useCases"));
var index_2 = __importDefault(require("./sections/superFans/index"));
var cardLayout_1 = __importDefault(require("../../../components/CardLayout/cardLayout"));
var index_module_scss_1 = __importDefault(require("./index.module.scss"));
var i18next_1 = require("i18next");
var react_i18next_1 = require("react-i18next");
var heroLayout_1 = __importDefault(require("../../../components/heroLayout"));
var faq_1 = __importDefault(require("../../faq"));
var getStarted_1 = __importDefault(require("./sections/getStarted"));
function StarsHome() {
    var language = localStorage.getItem("i18nextLng");
    var pattern = /(es)/;
    var _a = (0, react_1.useState)(false), showModel = _a[0], setShowModel = _a[1];
    var expandOurBrand = [
        {
            title: (0, i18next_1.t)("starsOurBrandOne"),
            url: "#",
            image: "/img/378617.svg",
            isIcon: true,
        },
        {
            title: (0, i18next_1.t)("starsOurBrandTwo"),
            url: "#",
            image: "/img/378618.svg",
            isIcon: true,
        },
        {
            title: (0, i18next_1.t)("starsOurBrandThree"),
            url: "#",
            image: "/img/378619.svg",
            isIcon: true,
        },
    ];
    return ((0, jsx_runtime_1.jsx)("main", __assign({ className: "homepage HomePageFull" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "home" }, { children: [(0, jsx_runtime_1.jsx)(index_1.default, { showModel: showModel, setShowModel: setShowModel }), (0, jsx_runtime_1.jsx)(getStarted_1.default, { isModel: true, showModel: showModel, setShowModel: setShowModel }), (0, jsx_runtime_1.jsx)(index_2.default, {}), (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.infoBackground, style: {
                        //background: "lightgray -86.823px -532.819px / 300.881% 190.414% no-repeat",
                        backgroundImage: "url(/superFansBg3.svg), url(/superFansBg4.svg)",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "left center, right center",
                        backgroundSize: "25%",
                    } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.infoSection }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: index_module_scss_1.default.headline }, { children: "FOR" })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.content }, { children: [(0, jsx_runtime_1.jsxs)("h3", { children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "musicians" }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "creators" }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "brands" }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "influencers" }) })] }), (0, jsx_runtime_1.jsx)("p", { dangerouslySetInnerHTML: { __html: (0, i18next_1.t)("forMusiciansMessage") } })] }))] })) })) })), (0, jsx_runtime_1.jsx)(cardLayout_1.default, { headline: (0, i18next_1.t)("starsOurBrandTitle"), center: true, list: expandOurBrand, bgOverlay: true, bgStyle: {
                        backgroundImage: "url(/img/starbg3.png)",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "contain",
                    } }), (0, jsx_runtime_1.jsx)(heroLayout_1.default, { headline: (0, i18next_1.t)("starsCreativity.title"), items: [
                        {
                            name: (0, i18next_1.t)("starsCreativity.itemOne"),
                        },
                        {
                            name: (0, i18next_1.t)("starsCreativity.itemTwo"),
                        },
                        {
                            name: (0, i18next_1.t)("starsCreativity.itemThree"),
                        },
                    ] }), (0, jsx_runtime_1.jsx)(useCases_1.default, {}), (0, jsx_runtime_1.jsx)(heroLayout_1.default, { headline: (0, i18next_1.t)("starsAudience.title"), bgStyle: {
                        backgroundImage: "url(/superFansBg6.png)",
                    }, items: [
                        {
                            name: (0, i18next_1.t)("starsAudience.itemOne"),
                        },
                        {
                            name: (0, i18next_1.t)("starsAudience.itemTwo"),
                        },
                        {
                            name: (0, i18next_1.t)("starsAudience.itemThree"),
                        },
                    ] }), (0, jsx_runtime_1.jsx)(heroLayout_1.default, { layout: "center", headline: (0, i18next_1.t)("starsCreatorPromo.title"), subHeadline: (0, i18next_1.t)("starsCreatorPromo.subText"), hasButton: true, buttonText: (0, i18next_1.t)("starsCreatorPromo.buttonText"), bgStyle: {
                        backgroundImage: "url(/superFansBg7.png)",
                        backgroundSize: "cover",
                    }, showModel: showModel, setShowModel: setShowModel }), pattern.test(language) && ((0, jsx_runtime_1.jsx)(faq_1.default, {}))] })) })));
}
exports.default = (0, react_router_dom_1.withRouter)(StarsHome);
